export default __webpack_public_path__ + "static/media/CAREER.95735547.png";